import $ from 'jquery';
import 'what-input';
import FooterAnimation from "./lib/animations/footer-animation.js";
import ClassToggle from './lib/em/ClassToggle';
import ScrollClass from './lib/em/ScrollClass.js';
import CustomPointer from './lib/em/CustomPointer.js';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
// window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';
import Header from './lib/em/Header';
$(document).foundation();

// Custom scripts
window.em = window.em || {};

window.em.header = new Header();
window.em.classToggle = new ClassToggle();
window.em.scrollClass = new ScrollClass();
window.em.customPointer = new CustomPointer();
//window.em.footerAnimation = new FooterAnimation();


